// @owners { team: patients }

import { SCROLLED_TO_BOTTOM } from '../../coupons/helpers/wrapHtmlContent';

type HandleTermsWebViewMessageArgs =
  | {
      data: string;
      expectedOrigin: string;
      isWeb: true;
      onScrolledToBottom?: () => void;
      origin: string;
    }
  | {
      data: string;
      isWeb: false;
      onContentHeight?: (height: number) => void;
      onScrolledToBottom?: () => void;
    };

export const handleTermsWebViewMessage = (args: HandleTermsWebViewMessageArgs) => {
  if (args.isWeb) {
    if (args.origin !== args.expectedOrigin) {
      return;
    }

    if (args.data === SCROLLED_TO_BOTTOM) {
      args.onScrolledToBottom?.();
    }

    return;
  }

  if (args.data === SCROLLED_TO_BOTTOM) {
    args.onScrolledToBottom?.();
    return;
  }

  try {
    const parsed = JSON.parse(args.data) as { type?: string; height?: number };
    if (parsed?.type === 'content_height' && typeof parsed.height === 'number') {
      args.onContentHeight?.(parsed.height);
    }
  } catch {
    // ignore non-JSON messages
  }
};
